import { useState, useCallback } from 'react';
import { usageTracker } from '../utils/tracker';
import { useAllHighlySensitivePropertyValues } from 'customer-data-properties/dataSensitivity/useAllHighlySensitivePropertyValues';
import { useCardContextValue } from '../state/CardContext';
const DEFAULT_HIGHLY_SENSITIVE_PROPERTY_VALUES = {};
export const usePropertyInputProps = () => {
  var _subjectResult$data;
  const {
    objectTypeId,
    objectId,
    asyncData: {
      subjectResult
    }
  } = useCardContextValue();
  const propertyValues = (_subjectResult$data = subjectResult.data) === null || _subjectResult$data === void 0 ? void 0 : _subjectResult$data.properties;
  const refetchSubject = subjectResult.refetch;
  const [draftValues, setDraftValues] = useState({});
  const highlySensitivePropertyValues = useAllHighlySensitivePropertyValues({
    objectTypeId,
    defaultValues: DEFAULT_HIGHLY_SENSITIVE_PROPERTY_VALUES
  });
  const hasDraftValue = useCallback(name => {
    return Object.prototype.hasOwnProperty.call(draftValues, name);
  }, [draftValues]);
  const getDraftValue = useCallback(name => {
    if (Object.prototype.hasOwnProperty.call(draftValues, name)) {
      return draftValues[name];
    }
    return undefined;
  }, [draftValues]);
  const onChange = useCallback(changes => {
    setDraftValues(prev => Object.assign({}, prev, changes));
  }, []);
  const onSave = useCallback(async updatesById => {
    const updates = updatesById[objectId];
    if (Object.keys(updates).length > 0) {
      usageTracker.track('Crm', 'Record Interactions', {
        action: 'Save property (new panel)',
        objectTypeId
      });
    }
    await refetchSubject();
    setDraftValues(prev => {
      const newValues = Object.assign({}, prev);
      Object.keys(updates).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(updates, key) && prev[key] === updates[key]) {
          delete newValues[key];
        }
      });
      return newValues;
    });
  }, [objectId, objectTypeId, refetchSubject]);
  const getSavedValue = useCallback(name => {
    var _propertyValues$name;
    return propertyValues ? (_propertyValues$name = propertyValues[name]) === null || _propertyValues$name === void 0 ? void 0 : _propertyValues$name.value : undefined;
  }, [propertyValues]);
  const getPropertyValue = useCallback(propertyName => {
    if (hasDraftValue(propertyName)) {
      return getDraftValue(propertyName);
    }
    const sensitivePropertyValues = highlySensitivePropertyValues[objectId];
    if (sensitivePropertyValues && Object.prototype.hasOwnProperty.call(sensitivePropertyValues, propertyName)) {
      return sensitivePropertyValues[propertyName];
    }
    return getSavedValue(propertyName);
  }, [hasDraftValue, getDraftValue, getSavedValue, highlySensitivePropertyValues, objectId]);
  return {
    getDraftValue,
    onChange,
    onSave,
    getSavedValue,
    hasDraftValue,
    getPropertyValue
  };
};